import React from 'react';
import { Navigate } from 'react-router-dom';

export default function Unsubscribe() {
  return <Navigate to="/settings#email-preferences" replace />;
}
